/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from '../actions/BonusItemDataServiceEntities.g';

// @ts-ignore
function bonusItemsQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'BonusItems',
        'MFIGetBonusItemsParameters',
        DataServiceEntities.MFIGetBonusItemsParametersExtensionClass,
        key
    );
}

export function createMFIGetBonusCouponsDetailsInput(bonusCoupons: string): IDataServiceRequest {
    const query = bonusItemsQuery();
    return query.createDataServiceRequestForOperation(
        'MFIGetBonusCouponsDetails',
        true,
        DataServiceEntities.MFIGetBonusCouponsDetailsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIGetBonusCouponsDetailsResponse' },
        { bonusCoupons: bonusCoupons }
    );
}

export function mFIGetBonusCouponsDetailsAsync(
    context: IContext,
    bonusCoupons: string
): AsyncResult<DataServiceEntities.IMFIGetBonusCouponsDetailsResponse> {
    const request = createMFIGetBonusCouponsDetailsInput(bonusCoupons);
    return callActionOrExecute<DataServiceEntities.IMFIGetBonusCouponsDetailsResponse>(request, context.callerContext);
}

export function createMFIGetBonusItemsDetailInput(bonusItemParams: DataServiceEntities.IMFIGetBonusItemsParameters): IDataServiceRequest {
    const query = bonusItemsQuery();
    return query.createDataServiceRequestForOperation(
        'MFIGetBonusItemsDetail',
        true,
        DataServiceEntities.MFIBonusItemsResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIBonusItemsResponse' },
        { bonusItemParams: bonusItemParams }
    );
}

export function mFIGetBonusItemsDetailAsync(
    context: IContext,
    bonusItemParams: DataServiceEntities.IMFIGetBonusItemsParameters
): AsyncResult<DataServiceEntities.IMFIBonusItemsResponse> {
    const request = createMFIGetBonusItemsDetailInput(bonusItemParams);
    return callActionOrExecute<DataServiceEntities.IMFIBonusItemsResponse>(request, context.callerContext);
}
